
import styled from "styled-components";
import { TifynFooter } from "@tiffin/components";
import { useAppSelector } from "../hooks";
import TifynLogo from "../assets/images/tifyn-logo.png"
import { NavBar } from "../components/NavBar";
import { ChatRoom } from "../components/messages/ChatRoom";
import { IonIcon } from "@ionic/react";
import { arrowBackOutline, chatboxOutline } from 'ionicons/icons';
import { Button } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useContext } from "react";
import { ViewContext } from "../Contexts";
import { MenuBar } from "../components/MenuBar";

export const Messages = styled(BaseMessages)`
  display: grid;
  grid-template-columns: auto 1fr;
  height: 100%;

  @media (max-width:768px) {
    grid-template-columns: 100%;
  }

  .header {
    background: #fff;
    padding: 20px;
    font-size: var(--font-size-medium);
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 5px;

    ion-icon {
      font-size: var(--font-size-xlarge);
    }
  }

  .page {
    display: grid;
    grid-template-rows: auto 1fr;
    height: calc(var(--vh, 1vh) * 100);

    .unauthenticated {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 20px;
      color: var(--ion-color-medium);
      font-weight: 600;
      margin: 10px;
      background: #fff;
      text-align: center;
      padding: 20px;
      border-radius: 8px;

      .unauthenticated-btns {
        display: flex;
        gap: 10px;
      }

      svg {
        width: 100px;
        height: fit-content;
      }
    }
  }
`

interface IMessages {
  className?: string
}

function BaseMessages({className}: IMessages) {

  const partner = useAppSelector((state) => state.store)
  const authenticateStatus = useAppSelector((state) => state.authenticate.status)

  const navigate = useNavigate()
  const [searchParams] = useSearchParams();

  const view = useContext(ViewContext);

  return (
    <div className={className}>
      {
        view === "web" && <NavBar />
      }
      <div className="page" style={{paddingBottom: authenticateStatus === "unauthenticated" && view === "mobile" ? 70 : 0}}>
        {
          partner.details &&
          <>
            <div className="header">
              {
                view === "mobile" &&
                <Button type="link" onClick={() => navigate(-1)}><IonIcon icon={arrowBackOutline} /></Button>
              }
              <IonIcon icon={chatboxOutline} />
              <span>Messages</span>
            </div>
            {
              authenticateStatus === "authenticated" &&
              <ChatRoom />
            }
            {
              authenticateStatus === "unauthenticated" &&
              <div className="unauthenticated">
                <span>You must create an account or log in to message the store</span>
                  <div className="unauthenticated-btns">
                    <Button onClick={() => navigate({pathname: `/${partner.details?.urlName}/signin`, search: searchParams.toString()})}>Log In</Button>
                    <Button onClick={() => navigate({pathname: `/${partner.details?.urlName}/signin`, search: searchParams.toString()})} type="primary">Sign Up</Button>
                  </div>
              </div>
            }
            {
              view === "web" &&
              <TifynFooter
                logoAlt="Tifyn Logo"
                logoSrc={TifynLogo}
              />
            }
          </>
        }
      </div>
      {
        (view === "mobile" && authenticateStatus === "unauthenticated") && <MenuBar />
      }
    </div>
  )
}